import { useTranslation } from 'react-i18next';
import InfoMessage from '.';

const NoResultsInfoMessage = () => {
  const { t } = useTranslation();
  return <InfoMessage icon="info" message={t('state.no_hits')} />;
};

export default NoResultsInfoMessage;
